<template>
    <div class="question-wrapper">
        <transition name="fade" appear>
            <div class="question" v-if="currentQuestion != false && currentQuestion <= questionsAmount">
                <div class="q-info">
                    Вопрос {{ currentQuestion }} из {{ questionsAmount }}
                </div>
                <h3 class="q-title" v-html="question.title"></h3>
                <div v-if="question.type == 'images'">
                    <ul class="images-list">
                        <li v-for="image in question.images" v-bind:key="image.number" :data-key="image.number" class="left-index-wrapper">
                            <span class="left-index">{{ image.number }}</span>
                            <img :src="image.src" alt="">
                            <span class="image-caption">{{ image.title }}</span>
                        </li>
                    </ul>
                </div>
                <div v-else-if="question.type == 'singleImage'">
                    <div class="single-image">
                        <img :src="question.images[0].src" alt="">
                    </div>
                </div>
            </div>
        </transition>
        <div class="variants-wrapper"
             v-if="currentQuestion != false && currentQuestion <= questionsAmount && question.selectedVariant == false">
            <p class="q-text" v-html="question.text"></p>
            <ul class="variants">
                <variant-item
                    v-if="currentQuestion != false"
                    v-for="variant in question.variants"
                    v-bind:key="variant.key"
                    :keynumber="variant.key"
                    :text="variant.text"
                    :imgSrc="variant.imgSrc"
                    :desc="variant.description"
                    :questionAnswered="question.selectedVariant != false"
                    :selectedVariant="selectedVariant"
                    :correctVariant="question.correctAnswer"
                    @variant-selected="selectVariant"
                ></variant-item>
            </ul>
        </div>

        <div v-if="selectedVariant != false" class="go-ahead-wrapper">
            <div class="after-answered-text-wrapper"
                 :class="{ correct: selectedVariant == question.correctAnswer, incorrect: selectedVariant != question.correctAnswer }"
                 v-html="'<p>' + selectedVariantObj.description + '</p>'">
            </div>

            <div class="controls-wrapper">
                <!--
                <button @click="prevQuestion">
                    Пред
                </button>
                -->
                <button @click="nextQuestion" class="control-btn left-index-wrapper"
                        v-if="currentQuestion < questionsAmount" style="padding-left: 35px!important">
                    <span class="left-index"></span>
                    {{ nextQuestionButtonText }}
                </button>
                <button @click="nextQuestion" class="control-btn left-index-wrapper" v-else>
                    <span class="left-index"></span>
                    {{ nextQuestionButtonText }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
// import Aplayer from 'vue-aplayer';
import VariantItem from './VariantItem.vue'
import { CSSPlugin } from 'gsap/all'
import { gsap } from 'gsap'
// import {TimelineLite, CSSPlugin, AttrPlugin} from 'gsap/all';

gsap.registerPlugin(CSSPlugin)

export default {
  data: function () {
    return {}
  },
  methods: {
    selectVariant: function (keyvalue) {
      const el = document.querySelectorAll('.variants-wrapper')
      if (el.length > 0) {
        gsap.to(el, 0.4, {
          opacity: 0,
          y: -20,
          onComplete: function (t, keyvalue) {
            t.$store.commit('setAnswer', { qKey: t.question.key, selectedVariant: keyvalue })
            setTimeout(function () {
              const el1 = (document.querySelectorAll('.go-ahead-wrapper'))
              // if (el1 && el1.style.opacity == 0) {
              if (el1.length > 0) {
                gsap.fromTo(el1, 0.5, { opacity: 0, y: -20 }, { opacity: 1, y: 0 })
              }
            }, 100)
          },
          onCompleteParams: [this, keyvalue]
        })
      }
      // this.question.selectedVariant = keyvalue;
    },
    nextQuestion: function () {
      const el = document.querySelectorAll('.question, .go-ahead-wrapper')
      if (el.length > 0) {
        gsap.to(el, 0.4, {
          opacity: 0,
          y: -20,
          onComplete: function (t) {
            t.$store.commit('nextQuestion')
            setTimeout(function () {
              const elem = (document.querySelector('.variants-wrapper'))
              if (elem) {
                gsap.to(elem, 0.5, { opacity: 1, y: 0 })
              }
            }, 100)
          },
          onCompleteParams: [this]
        })
      }
    },
    prevQuestion: function () {
      this.$store.commit('prevQuestion')
    }
  },
  computed: {
    question: function () {
      return this.$store.getters.currentQuestionObject
    },
    currentQuestion: function () {
      return this.$store.getters.currentQuestion
    },
    questionsAmount: function () {
      return this.$store.getters.questionsAmount
    },
    /** returns integer  key of selected variant of this question **/
    selectedVariant: function () {
      const r = this.$store.getters.selectedVariantOfQuestion(
        { qKey: this.question.key }
      )
      if (r !== false) {
      }
      return r
    },
    selectedVariantObj: function () {
      var q = this.question
      var result = false
      for (var k = 0; k < q.variants.length; k++) {
        if (q.variants[k].key === this.selectedVariant) {
          result = q.variants[k]
          break
        }
      }
      return result
    },
    nextQuestionButtonText: function () {
      return this.$store.state.nextQuestionButtonText
    },
    resultsButtonText: function () {
      return this.$store.state.resultsButtonText
    }
  },
  watch: {
    currentQuestion: function (nV, oV) {}
  },
  components: {
    VariantItem
  },
  beforeUpdate: function () {
  },
  updated: function () {
  }
}
</script>

<style lang="scss">
</style>
